module.exports = __webpack_public_path__ + "img/LK.c26292c2.svg";